import Button from 'components/_other/button/Button';

export const InputWithButton = ({inputProps, icon = null, buttonProps, error}) => {
  return (
      <>
        <div className={`relative w-full flex items-center justify-center rounded-lg overflow-clip border ${error ? 'border-danger' : 'border-primary'} border-solid !h-[50px]`}>
            {icon ? (
                <div className={"[&>svg]:h-[16px] absolute top-1/2 left-6 z-10 -translate-y-1/2 pb-1"}>
                    {icon}
                </div>
            ) : null}
          <input className={`w-full h-[50px] py-2 ${icon ? 'pl-14' : 'pl-4'} pr-28 md:pr-32 text-font`} {...inputProps} />
          <Button size="mediumWithSmallText" className={"absolute right-0 top-0 !h-[48px] !px-7 rounded-l-lg !rounded-r-md"} {...buttonProps}>{buttonProps?.content}</Button>
        </div>
        {error ? <div className={'text-danger text-sm mt-2'}>{error}</div> : null}
      </>
  );
};
